<template>
  <div class="container">
    <p class="text-justify">
      Thank you for your interest in subscribing to the Wervingsdagen events of 2019-2020. Please accept our privacy policy to continue.
    </p>
    <p>
      I have read the
      <a target="_blank" href="https://wervingsdagen.nl/privacy">privacy policy</a> and agree.
    </p>
    <YesNo v-model="privacy" name="privacy" />
    <router-link to="/packages">
      <button class="btn btn-secondary">Back</button>
    </router-link>
    <router-link to="/subscribe/contact-information" v-if="privacy">
      <button class="btn btn-primary">Next</button>
    </router-link>
    <button class="btn btn-primary" disabled v-else>Next</button>
  </div>
</template>

<script>
import YesNo from "@/components/YesNo.vue";

export default {
  name: "experience-center",
  components: {
    YesNo
  },
  data() {
    return {
      privacy: false
    };
  }
};
</script>